import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from '@/components/ui/Button/Button';
import { LockIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Tooltip } from '@/components/ui/Tooltip/Tooltip';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * セミナー詳細の資料を表示するためのボタン
 * @param props
 * @constructor
 */
export const SeminarCliDocumentButton = (props) => {
    const { buttonText, className = '', isShowLockIcon = false, onClick, tooltipHtml, value, } = props;
    return (_jsx(Button, Object.assign({ className: className, color: 'navy', isFull: true, onClick: onClick, size: 'md', value: value }, { children: _jsx(Tooltip, Object.assign({ arrow: true, html: tooltipHtml }, { children: _jsxs(IconTextGroup, { children: [buttonText, isShowLockIcon && _jsx(LockIcon, { color: 'white', size: 'md' })] }) })) })));
};
